const banners_en = require('./banners.json')
export default banners_en